import { makeVar } from "@apollo/client";
import { RideUpdateError } from "./types";

const rideUpdateErrorsVar = makeVar<Array<RideUpdateError>>([]);

export default rideUpdateErrorsVar;
